<template>
  <tr>
    <td align="left">
      <template v-if="!isBuilder"> [[GLOBAL;SIGNATURE]] </template>

      <template v-else>
        <div>
          <p>[[Email Signature]]</p>
          <p>
            <small>
              This block will output the email signature of the user sending the
              email. Your email signature can be edited from your user profile.
            </small>
          </p>
        </div>
      </template>
    </td>
  </tr>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-email-template-signature></ak-email-template-signature>
   */
  name: 'AkEmailTemplateSignature',

  /**
   * @type {Boolean}
   * @description This prevents all element attributes that are not
   * defined in the props object from being applied to the rendered
   * component root element, the exception to this is "class" all
   * of the given classes would be merged with the component
   * defined ones.
   */
  inheritAttrs: false,

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {Boolean}
     * @description Determines if we are to render the block for the
     * builder component (drag and drop editor)
     */
    isBuilder: {
      type: Boolean,
      default: false,
    },

    /**
     * @type {Number}
     * @description Block index
     */
    blockIndex: {
      type: Number,
      default: 0,
    },

    /**
     * @type {Number}
     * @description Content index
     */
    contentIndex: {
      type: Number,
      default: 0,
    },

    /**
     * @type {Boolean}
     * @description Determines if the content item is the last in its column
     */
    isLast: {
      type: Boolean,
      default: false,
    },

    /**
     * @type {Boolean}
     * @description Has flush spacing on the block
     */
    isFlush: {
      type: Boolean,
      default: false,
    },

    /**
     * @type {String}
     * @description The container in which to position the drawers
     */
    drawerContainer: {
      type: String,
      default: null,
    },
  },
})
</script>
